const DynamicIcon = ({ icon, className = "" }) => {
  const isSvgUrl =
    typeof icon === "string" &&
    (icon.includes("/static/media/") || icon.endsWith(".svg"));
  const isSvgComponent =
    typeof icon === "function" || (typeof icon === "object" && icon.$$typeof);
  const isFontAwesome = typeof icon === "string" && icon.startsWith("fa-");

  const isEmoji =
    typeof icon === "string" &&
    !isFontAwesome &&
    !isSvgUrl &&
    icon.startsWith("emoji:");

  const commonStyle = {
    fontSize: 16,
    width: 20,
    height: 16,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  };

  return (
    <span className={`action-icon-container ${className}`} style={commonStyle}>
      {isSvgUrl && (
        <img src={icon} style={{ width: "1em", height: "1em" }} alt="icon" />
      )}

      {isSvgComponent &&
        (() => {
          const IconComponent = icon;
          return <IconComponent style={{ width: "1em", height: "1em" }} />;
        })()}

      {isFontAwesome && <i className={`far ${icon}`} />}

      {isEmoji && <span style={{ lineHeight: 1 }}>{icon.substring(6)}</span>}
    </span>
  );
};

export default DynamicIcon;
